export default "__VITE_ASSET__BUjUMCk1__"